module.exports = __webpack_public_path__ + "static/media/arrow.ff0230d6.svg";